export const FILTER_CATEGORY_CODES = {
  AVAILABILITY_FILTERS: 'availabilityFilters',
  BUNDLE_PRICE_FILTERS: 'bundlePriceValue',
  CURRENTLY_UNAVAILABLE_FILTERS: 'currentlyUnavailableFilters',
  DEALS_AND_REBATES_FILTERS: 'dealAndRebateFilters',
  PRICE_FILTERS: 'priceValue',
  QUICK_FILTERS: 'quickFilters'
};

export const FILTER_KEYS = {
  ASPECT_RATIO: 'aspectRatio',
  ATV_OFFSET: 'atvOffset',
  BACKORDERED: ['backOrdered', 'backorderedSets', 'bundleBackorderedProduct'],
  BLADE_LENGTH: 'bladeLength',
  BOLT_PATTERN: 'boltPattern',
  CHAIN_ASPECT_RATIO: 'chainAspectRatio',
  CHAIN_DIAMETER: 'chainDiameter',
  CHAIN_SECTION_WIDTH: 'chainSectionWidth',
  COLOR: 'color',
  CROSS_SECTION: 'crossSection',
  DISCONTINUED: [
    'disContinued',
    'discontinuedSets',
    'bundleDiscontinuedProduct'
  ],
  INSTANT_SAVINGS: 'instantSavings-boolean',
  INTERNAL_LENGTH: 'internalLength',
  INVENTORY_STATUS: 'inventoryStatus',
  LOAD_INDEX_WITH_RATING_KEY: 'loadIndexWithRatingKey',
  LOAD_RANGE: 'loadRange',
  LUG_TYPE: 'lugType',
  MANUFACTURER_AID: 'manufacturerAID',
  OE: 'oe-boolean',
  OFFSET: 'offset',
  ORIGINAL_EQUIPMENT_2: 'origEquipment2',
  REBATES: 'rebates-boolean',
  RIM_DIAMETER: 'rimDiameter',
  SEAT_TYPE: 'seatType',
  SIDEWALL_DESCRIPTION: 'sideWallDescription',
  SPECIAL_OFFERS: 'specialOffers-boolean',
  STORE_IN_STOCK: 'storeInStock',
  SWATCH_CODE: 'swatchCode',
  TEMPORARILY_UNAVAILABLE: 'temporarilyUnavailable',
  THREAD_DIAMETER: 'threadDiameter',
  THREAD_PITCH: 'threadPitch',
  THREE_PEAK_MOUNTAIN: 'threePeakMountain-boolean',
  TIRE_CATEGORY: 'tireCategory',
  VENDOR_STOCK_AVAILABILITY_DAYS: 'vendorStockAvailabilityDays',
  WHEEL_RIM_DIAMETER: 'wheelRimDiameter',
  WHEEL_WIDTH: 'wheelWidth',
  WINTER_TIRES: 'winterTires'
};

export const ACCESSORY_FILTER_KEYS = {
  BLADE_LENGTH: FILTER_KEYS.BLADE_LENGTH,
  CHAIN_ASPECT_RATIO: FILTER_KEYS.CHAIN_ASPECT_RATIO,
  CHAIN_DIAMETER: FILTER_KEYS.CHAIN_DIAMETER,
  CHAIN_SECTION_WIDTH: FILTER_KEYS.CHAIN_SECTION_WIDTH,
  COLOR: FILTER_KEYS.COLOR,
  INTERNAL_LENGTH: FILTER_KEYS.INTERNAL_LENGTH,
  LUG_TYPE: FILTER_KEYS.LUG_TYPE,
  SEAT_TYPE: FILTER_KEYS.SEAT_TYPE,
  THREAD_DIAMETER: FILTER_KEYS.THREAD_DIAMETER,
  THREAD_PITCH: FILTER_KEYS.THREAD_PITCH
};

export const CURRENTLY_UNAVAILABLE_KEYS = {
  BACKORDERED: FILTER_KEYS.BACKORDERED,
  DISCONTINUED: FILTER_KEYS.DISCONTINUED,
  TEMPORARILY_UNAVAILABLE: FILTER_KEYS.TEMPORARILY_UNAVAILABLE
};

export const DEAL_AND_REBATE_KEYS = {
  INSTANT_SAVINGS: FILTER_KEYS.INSTANT_SAVINGS,
  REBATES: FILTER_KEYS.REBATES,
  SPECIAL_OFFERS: FILTER_KEYS.SPECIAL_OFFERS
};

export const AVAILABILITY_KEYS = {
  STORE_IN_STOCK: FILTER_KEYS.STORE_IN_STOCK,
  VENDOR_STOCK_AVAILABILITY_DAYS: FILTER_KEYS.VENDOR_STOCK_AVAILABILITY_DAYS
};

export const TIRE_FILTER_KEYS = {
  ASPECT_RATIO: FILTER_KEYS.ASPECT_RATIO,
  CROSS_SECTION: FILTER_KEYS.CROSS_SECTION,
  LOAD_INDEX: FILTER_KEYS.LOAD_INDEX_WITH_RATING_KEY,
  LOAD_RANGE: FILTER_KEYS.LOAD_RANGE,
  MANUFACTURER_AID: FILTER_KEYS.MANUFACTURER_AID,
  ORIGINAL_EQUIPMENT: FILTER_KEYS.ORIGINAL_EQUIPMENT_2,
  RIM_DIAMETER: FILTER_KEYS.RIM_DIAMETER,
  SIDEWALL_DESCRIPTION: FILTER_KEYS.SIDEWALL_DESCRIPTION
};

export const WHEEL_FILTER_KEYS = {
  ATV_OFFSET: FILTER_KEYS.ATV_OFFSET,
  BOLT_PATTERN: FILTER_KEYS.BOLT_PATTERN,
  COLOR: FILTER_KEYS.SWATCH_CODE,
  MANUFACTURER_AID: FILTER_KEYS.MANUFACTURER_AID,
  OFFSET: FILTER_KEYS.OFFSET,
  RIM_DIAMETER: FILTER_KEYS.WHEEL_RIM_DIAMETER,
  WIDTH: FILTER_KEYS.WHEEL_WIDTH
};
